import { Pipe, PipeTransform } from '@angular/core';
import { UnderlyingAssetArrayFE } from 'src/app/product-capture/model/interfaces/underlying-asset-array-fe.interface';
import { UnderlyingAssetsFE } from 'src/app/product-capture/model/interfaces/underlying-assets-fe.interface';

@Pipe({
  name: 'filterAssets',
})
export class FilterAssetsPipe implements PipeTransform {
  transform(
    underlyingAssetsItems: UnderlyingAssetsFE[],
    underlyingAssets: UnderlyingAssetArrayFE[]
  ): UnderlyingAssetsFE[] {
    if (!underlyingAssets) {
      return underlyingAssetsItems;
    }

    const filteredUnderlyingAssetItems = underlyingAssetsItems.filter(
      (item) => !underlyingAssets.some((asset) => asset.assetId === item.id)
    );

    return filteredUnderlyingAssetItems;
  }
}
